export default __webpack_public_path__ + "static/media/ravi.4e887896.jpeg";